import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["variant", "as", "className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Typography component renders text with different styles and variants.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {'headline-xl'|'headline-l'|'headline-m'|'headline-s'|'headline-xs'|'body-l'|'body-m'|'body-s'|'mini'|'button'|'preamble'|'section-heading'} [props.variant='body-m'] - The variant of the typography.
 * @param {React.ElementType} [props.as=null] - The HTML element type to render.
 * @param {string} [props.className=null] - Additional CSS class name.
 * @param {React.ReactNode} props.children - The content to be rendered inside the typography.
 * @param {Object} [props.rest=null] - The rest of the props.
 * @returns {React.ReactNode} The rendered typography component.
 */
var Typography = function Typography(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'body-m' : _ref$variant,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? null : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Type = as || 'p';
  return /*#__PURE__*/jsx(Type, _objectSpread(_objectSpread({
    className: "uikit-font-".concat(variant, " ").concat(className || '')
  }, rest), {}, {
    children: children
  }));
};
var Typography$1 = Typography;

export { Typography$1 as default };
//# sourceMappingURL=Typography.js.map
